export enum PaymentType {
    CREDIT_CARD = 'credit-card',
    PAYPAL = 'paypal',
    APPLE_PAY = 'apple_pay',
    GOOGLE_PAY = 'google_pay',
    WHOP = 'whop',
}